import {FC} from "react";
import {DepartmentGalleryProps} from "./types";
import {Image} from "antd";
import "./style.less"


const Gallery: FC<DepartmentGalleryProps> = (props) => {
  const {images} = props
  return (<div className="department_gallery">
    <Image.PreviewGroup>
      {images.map((src, index) => (
        <div key={index} className="gallery_item_wrapper">
          <Image
            className="gallery_image"
            key={index}
            width={250}
            src={src}
            preview={{src}}
            alt={`Gallery image ${index + 1}`}

          />

        </div>
      ))}
    </Image.PreviewGroup>
  </div>)
}

export default Gallery